import request from '@/utils/request'

const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST

export function getLeadListApi(params) {
  return request({
    url: jsApiHost + '/god/lead/list',
    method: 'get',
    params
  })
}

export function getClueReportListApi(params) {
  return request({
    url: jsApiHost + '/company/query',
    method: 'get',
    params
  })
}
